export default "__VITE_ASSET__DQx8Co1H__"